import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
	selector: 'app-beta-fe',
	templateUrl: './beta-fe.dialog.component.html',
	providers: [DialogService],
})

export class BetaFeDialogComponent {
	constructor(
		public dialogService: DialogService
	){
	}

}
